<div class="container">
    
    <mat-toolbar>      
      <span>Lista de env&iacute;o</span>
      <span class="sgd-spacer"></span>
      <button mat-flat-button color="primary" (click)="onNew()">
                Nuevo
                  </button>
    </mat-toolbar>

    <div *ngIf="(dataSource.data.length || 0) === 0" class="no-data">
        <p>No hay listas de envío disponibles.</p>
    </div>


    <table mat-table [dataSource]="dataSource" *ngIf="(dataSource.data.length || 0) > 0">

        <!-- Titulo Column -->
        <ng-container matColumnDef="titulo">
            <th mat-header-cell *matHeaderCellDef>Nombre</th>
            <td mat-cell *matCellDef="let element">{{ element.titulo || element.nombre || element.nombreLista || element.tituloLista || element.descripcion || element.name }}</td>
        </ng-container>

        <!-- Acciones Column -->
        <ng-container matColumnDef="acciones">
            <th mat-header-cell *matHeaderCellDef class="acciones">&nbsp;</th>
            <td mat-cell *matCellDef="let element" class="acciones">
                <button mat-icon-button matTooltip="Editar" (click)="onEdit(element)">
                    <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button matTooltip="Eliminar" (click)="onDelete(element)">
                    <mat-icon>delete</mat-icon>
                </button>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</div>
